module.exports = __webpack_public_path__ + "components/flag/static/square/ph-c02903e9659c9482a759bda06f792b42.svg";